/* Ajax Fanatiek (2026-10-03): comportamento dos blocos da pagina de produto (estilo Match Day).
   Guia de medidas, personalizacao com previa, estoque real da variante e prazo de entrega. */
(function () {
  'use strict';

  // ---------- Guia de medidas (tabelas da matchdayofc.com, 03/10/2026) ----------
  // Valores em cm / kg; o botao "in / lb" converte na hora. Categoria vem de data-ajx-sg-cat (men | women | kids).
  // kids: os tamanhos da loja sao por altura (104..176); as faixas de idade/altura sao as da Matchday.
  //       A linha 176 e extrapolada (a Matchday para em 12-13 anos / 155-165 cm).
  var SG_TABLES = {
    men: { cols: ['size', 'height', 'width', 'length', 'weight'], rows: [
      ['S', [162, 170], 50, 72, [50, 62]], ['M', [170, 176], 52, 74, [62, 78]], ['L', [176, 182], 54, 76, [78, 83]],
      ['XL', [182, 190], 56, 78, [83, 90]], ['2XL', [190, 195], 58, 80, [90, 97]], ['3XL', [192, 197], 60, 82, [97, 104]],
      ['4XL', [197, 200], 62, 84, [104, 110]] ] },
    women: { cols: ['size', 'height', 'bust', 'length', 'weight'], rows: [
      ['S', [150, 160], 44, 65, [50, 62]], ['M', [160, 165], 46, 67, [62, 78]], ['L', [165, 170], 48, 69, [78, 83]],
      ['XL', [170, 175], 49.5, 70, [83, 90]], ['2XL', [175, 178], 51, 71, [90, 97]] ] },
    kids: { cols: ['size', 'age', 'height', 'width', 'length', 'waist'], rows: [
      ['104', '3-4', [95, 105], 35, 44, [20, 37]], ['110', '4-5', [105, 115], 37, 47, [21, 39]], ['116', '5-6', [115, 125], 39, 50, [22, 41]],
      ['128', '6-7', [125, 135], 41, 53, [23, 42]], ['140', '8-9', [135, 145], 43, 56, [24, 44]], ['152', '10-11', [145, 155], 45, 59, [25, 47]],
      ['164', '12-13', [155, 165], 47, 62, [26, 50]], ['176', '13-14', [165, 176], 49, 65, [27, 52]] ] }
  };
  var SG_KIND = { height: 'len', width: 'len', bust: 'len', length: 'len', waist: 'len', weight: 'wt', age: '', size: '' };
  function conv(v, u, kind) {
    if (u !== 'in' || !kind) return v;
    return kind === 'wt' ? Math.round(v * 2.2046) : Math.round(v / 2.54);
  }
  function faixa(a, u, kind) { return Array.isArray(a) ? conv(a[0], u, kind) + ' - ' + conv(a[1], u, kind) : conv(a, u, kind); }
  function tamanhoAtual() {
    var r = document.querySelector('variant-selects input[type=radio]:checked');
    var sel = document.querySelectorAll('variant-selects input[type=radio]:checked');
    for (var i = 0; i < sel.length; i++) {
      if (/^(size|maat)$/i.test(sel[i].dataset.optionName || '')) return sel[i].value;
    }
    return r ? r.value : '';
  }
  function desenhaTabela(box, u) {
    var table = box.querySelector('[data-ajx-sg-table]'); if (!table) return;
    var cat = box.dataset.ajxSgCat || 'men';
    var T = SG_TABLES[cat] || SG_TABLES.men;
    var head = table.querySelector('thead'), tb = table.querySelector('tbody');
    var atual = String(tamanhoAtual()).toUpperCase();
    var unit = function (kind) { return kind === 'len' ? (u === 'in' ? 'in' : 'cm') : kind === 'wt' ? (u === 'in' ? 'lb' : 'kg') : ''; };
    if (head) {
      head.innerHTML = '<tr>' + T.cols.map(function (c) {
        var lbl = table.getAttribute('data-l-' + c) || c, k = SG_KIND[c];
        return '<th>' + lbl + (k ? '<small>' + unit(k) + '</small>' : '') + '</th>';
      }).join('') + '</tr>';
    }
    if (tb) {
      tb.innerHTML = T.rows.map(function (r) {
        var on = String(r[0]).toUpperCase() === atual;
        return '<tr' + (on ? ' class="is-sel"' : '') + '>' + r.map(function (v, i) {
          var c = T.cols[i];
          if (i === 0) return '<td>' + v + (on ? '<em>' + (box.dataset.ajxSgSel || 'Gekozen') + '</em>' : '') + '</td>';
          return '<td>' + faixa(v, u, SG_KIND[c]) + '</td>';
        }).join('') + '</tr>';
      }).join('');
    }
    box.querySelectorAll('[data-ajx-unit]').forEach(function (bt) { bt.classList.toggle('is-on', bt.dataset.ajxUnit === u); });
  }
  document.addEventListener('click', function (e) {
    var abre = e.target.closest('[data-ajx-sg-open]');
    if (abre) {
      var box = document.querySelector('[data-ajx-sg]');
      if (!box) return;
      if (box.parentElement !== document.body) document.body.appendChild(box);
      desenhaTabela(box, box.dataset.unit || 'cm');
      box.hidden = false; document.documentElement.classList.add('ajx-lock');
      return;
    }
    if (e.target.closest('[data-ajx-sg-close]')) {
      var b = document.querySelector('[data-ajx-sg]'); if (b) b.hidden = true;
      document.documentElement.classList.remove('ajx-lock');
      return;
    }
    var un = e.target.closest('[data-ajx-unit]');
    if (un) { var bx = un.closest('[data-ajx-sg]'); bx.dataset.unit = un.dataset.ajxUnit; desenhaTabela(bx, un.dataset.ajxUnit); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var b = document.querySelector('[data-ajx-sg]'); if (b && !b.hidden) { b.hidden = true; document.documentElement.classList.remove('ajx-lock'); } }
  });

  // ---------- Personalizacao: aciona a opcao de variante "com/sem personalizacao" ----------
  function radiosDaOpcao(cz) {
    var nome = cz.dataset.optionName;
    return Array.prototype.filter.call(document.querySelectorAll('variant-selects input[type=radio], variant-selects option'), function (i) {
      return (i.dataset.optionName || '') === nome || (i.name || '').indexOf(nome) === 0;
    });
  }
  function estado(cz) {
    var on = cz.dataset.on;
    var marcado = radiosDaOpcao(cz).filter(function (i) { return i.checked || i.selected; })[0];
    return marcado && marcado.value === on;
  }
  function pinta(cz) {
    var ligado = estado(cz);
    cz.querySelectorAll('[data-ajx-cz-set]').forEach(function (b) { b.classList.toggle('is-on', (b.dataset.ajxCzSet === 'on') === ligado); });
    var st = cz.querySelector('[data-ajx-cz-state]'); if (st) st.textContent = ligado ? cz.dataset.on : cz.dataset.off;
    var panel = cz.querySelector('[data-ajx-cz-panel]'); if (panel) panel.hidden = !ligado;
    cz.querySelectorAll('[data-ajx-cz-name],[data-ajx-cz-num]').forEach(function (i) { i.disabled = !ligado; });
    var pv = cz.querySelector('[data-ajx-patch-val]'), pc = cz.querySelector('[data-ajx-patch]');
    if (pv && pc) pv.disabled = !pc.checked;
  }
  function seleciona(cz, quer) {
    var alvo = quer ? cz.dataset.on : cz.dataset.off;
    var r = radiosDaOpcao(cz).filter(function (i) { return i.value === alvo; })[0];
    if (!r) return;
    if (r.tagName === 'OPTION') { r.selected = true; r.parentElement.dispatchEvent(new Event('change', { bubbles: true })); }
    else { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    setTimeout(function () { pinta(cz); }, 60);
  }
  // Glifos acentuados que existem na fonte oficial: Á Ã Ç Ć Č É Í Ñ Ö Ó Š Ü Ú Ž
  var GLIFOS_ACENTO = [0xc1, 0xc3, 0xc7, 0x106, 0x10c, 0xc9, 0xcd, 0xd1, 0xd6, 0xd3, 0x160, 0xdc, 0xda, 0x17d];
  function arquivoGlifo(ch, tipo) {
    if (tipo === 'digits') return /^[0-9]$/.test(ch) ? ch : null;
    var up = ch.toUpperCase();
    if (/^[A-Z]$/.test(up)) return up;
    if (up === '.') return 'period';
    if (up === '-') return 'hyphen';
    var cp = up.codePointAt(0);
    if (GLIFOS_ACENTO.indexOf(cp) !== -1) return 'U' + ('0000' + cp.toString(16).toUpperCase()).slice(-4);
    var plano = up.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return /^[A-Z]$/.test(plano) ? plano : null;
  }
  function desenhaGlifos(alvo, texto, tipo, base, kit) {
    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(String(texto || ''), function (ch) {
      if (ch === ' ') { var gap = document.createElement('i'); gap.className = 'ajx-cz__gap'; frag.appendChild(gap); return; }
      var arq = arquivoGlifo(ch, tipo); if (!arq) return;
      var img = document.createElement('img');
      img.src = base + '/' + kit + '/' + tipo + '/' + arq + '.png';
      img.alt = ch; img.draggable = false; img.decoding = 'async';
      frag.appendChild(img);
    });
    alvo.textContent = '';
    alvo.appendChild(frag);
  }
  function previa(cz) {
    var n = cz.querySelector('[data-ajx-cz-name]'), m = cz.querySelector('[data-ajx-cz-num]');
    var pn = cz.querySelector('[data-ajx-cz-pname]'), pm = cz.querySelector('[data-ajx-cz-pnum]');
    var base = (cz.dataset.fontBase || '').replace(/\/+$/, ''), kit = cz.dataset.kit || '';
    if (base && kit) {
      // Fonte oficial do kit: uma imagem por letra/numero, todas com a mesma altura (linha de base igual)
      if (pn) { pn.classList.add('is-img'); }
      if (pm) { pm.classList.add('is-img'); }
      if (pn && n) desenhaGlifos(pn, n.value, 'letters', base, kit);
      if (pm && m) desenhaGlifos(pm, m.value, 'digits', base, kit);
      return;
    }
    if (pn && n) pn.textContent = n.value.toUpperCase();
    if (pm && m) pm.textContent = m.value;
  }
  function iniciaCz() {
    document.querySelectorAll('[data-ajx-cz]').forEach(function (cz) {
      if (cz.dataset.pronto) { pinta(cz); return; }
      cz.dataset.pronto = '1';
      cz.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ajx-cz-set]'); if (b) seleciona(cz, b.dataset.ajxCzSet === 'on');
      });
      cz.addEventListener('input', function (e) {
        if (e.target.matches('[data-ajx-cz-num]')) e.target.value = e.target.value.replace(/\D/g, '').slice(0, 2);
        if (e.target.matches('[data-ajx-cz-name]')) e.target.value = e.target.value.replace(/[^A-Za-zÀ-ÿ .'-]/g, '').slice(0, 12);
        previa(cz);
      });
      cz.addEventListener('change', function (e) { if (e.target.matches('[data-ajx-patch]')) pinta(cz); });
      pinta(cz); previa(cz);
    });
  }

  // ---------- Estoque real da variante (so mostra se a loja rastreia e nao vende sem estoque) ----------
  function estoque(idVar) {
    document.querySelectorAll('[data-ajx-stock]').forEach(function (box) {
      var dados = {}; try { dados = JSON.parse(box.querySelector('[data-ajx-stock-json]').textContent); } catch (e) {}
      var id = String(idVar || box.querySelector('[data-ajx-stock-sel]').textContent.trim());
      var v = dados[id]; var lim = parseInt(box.dataset.limite, 10) || 10;
      if (!v || v.m !== 'shopify' || v.p !== 'deny' || v.q <= 0 || v.q > lim) { box.hidden = true; return; }
      box.querySelector('[data-ajx-stock-txt]').textContent = box.dataset.tpl.replace('{n}', v.q);
      box.querySelector('[data-ajx-stock-fill]').style.width = Math.max(8, Math.round(v.q / lim * 100)) + '%';
      box.hidden = false;
    });
  }

  // ---------- Prazo de entrega em dias uteis (do prazo real configurado no bloco) ----------
  function maisDiasUteis(d, n) {
    var x = new Date(d); var c = 0;
    while (c < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) c++; }
    return x;
  }
  function entrega() {
    document.querySelectorAll('[data-ajx-ship]').forEach(function (b) {
      var hoje = new Date(); var f = { weekday: 'short', day: 'numeric', month: 'short' };
      var a = maisDiasUteis(hoje, parseInt(b.dataset.min, 10) || 5), z = maisDiasUteis(hoje, parseInt(b.dataset.max, 10) || 8);
      var lang = document.documentElement.lang || 'nl';
      b.querySelector('[data-ajx-ship-dates]').textContent = a.toLocaleDateString(lang, f) + ' - ' + z.toLocaleDateString(lang, f);
    });
  }

  // ---------- Barra de escassez: regra copiada do site da BlackHype (blackhypeworld.com, 03/10/2026) ----------
  // hash do NOME DO TAMANHO escolhido -> unidades = hash % 8 + 3 (3 a 10), barra = hash % 16 + 75 (%).
  // Some quando a variante esta esgotada (botao de compra desabilitado). Recalcula ao trocar o tamanho.
  function hashTamanho(s) {
    var hash = 0;
    for (var i = 0; i < s.length; i++) { hash = s.charCodeAt(i) + ((hash << 5) - hash); }
    return Math.abs(hash);
  }
  function escassez() {
    document.querySelectorAll('[data-ajx-scarce]').forEach(function (box) {
      var size = tamanhoAtual() || 'default';
      var h = hashTamanho(size);
      var n = (h % 8) + 3, pct = (h % 16) + 75;
      var strong = box.querySelector('.ajx-scarce__msg strong'); if (strong) strong.textContent = n;
      var fill = box.querySelector('.ajx-scarce__fill'); if (fill) fill.style.width = pct + '%';
      var btn = document.querySelector('product-form .product-form__submit, .product-form__submit');
      box.hidden = !!(btn && btn.disabled);
    });
  }
  // ---------- Patch: adiciona o produto do badge junto com o shirt (03/10/2026) ----------
  // Shirt e badge recebem a mesma propriedade _patch_link; o badge ainda leva _jersey_key.
  // O cart drawer (copiado do ajax-claude) usa isso para mostrar o badge embaixo do shirt em vez de linha separada.
  function propsDoForm(form) {
    var props = {};
    form.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]').forEach(function (i) {
      if (i.disabled) return;
      var k = i.name.slice(11, -1); if (!k) return;
      if ((i.type === 'checkbox' || i.type === 'radio') && !i.checked) return;
      if (i.value !== '') props[k] = i.value;
    });
    document.querySelectorAll('[form="' + form.id + '"][name^="properties["]').forEach(function (i) {
      if (i.disabled) return;
      var k = i.name.slice(11, -1); if (!k) return;
      if ((i.type === 'checkbox' || i.type === 'radio') && !i.checked) return;
      if (i.value !== '') props[k] = i.value;
    });
    return props;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var cz = document.querySelector('[data-ajx-cz]'); if (!cz) return;
    var pc = cz.querySelector('[data-ajx-patch]');
    if (!pc || !pc.checked || !pc.dataset.ajxPatchVariant) return;
    var idEl = form.querySelector('[name="id"]'); if (!idEl) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var qtyEl = form.querySelector('[name="quantity"]') || document.querySelector('[form="' + form.id + '"][name="quantity"]');
    var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
    var key = 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var props = propsDoForm(form); props._patch_link = key;
    var items = [
      { id: parseInt(idEl.value, 10), quantity: qty, properties: props },
      { id: parseInt(pc.dataset.ajxPatchVariant, 10), quantity: qty, properties: { _patch_link: key, _jersey_key: key } }
    ];
    var btn = form.querySelector('[type="submit"]'); if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch((window.routes && routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status) { alert(resp.description || resp.message || 'Fout'); return; }
        if (drawer && typeof drawer.renderContents === 'function') {
          if (!resp.sections) { drawer.setActiveElement(document.activeElement); drawer.open(); return; }
          drawer.renderContents(resp);
        } else { window.location = (window.routes && routes.cart_url) || '/cart'; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: resp });
        }
      })
      .catch(function () { window.location = '/cart'; })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
  }, true);
  function tudo() { iniciaCz(); estoque(); entrega(); escassez(); }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('variant-selects input, variant-selects select')) setTimeout(escassez, 120);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo); else tudo();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var v = ev && ev.data && ev.data.variant;
      setTimeout(function () { iniciaCz(); if (v) estoque(v.id); escassez(); }, 50);
    });
  }
})();
